import React from "react";
import { Title } from "../../../../styles/Modos.styles";
import * as S from "../../TableMuscles.styles";

export const TableMuscles = ({ t }) => {
  const tableHeaders = [t("muscles"), 1, 2, 3, 4, 5, 6];
  const tableData = [
    {
      muscle: t("quadriceps"),
      1: <S.Check className="__blue" />,
      2: false,
      3: false,
      4: <S.Check className="__blue" />,
      5: false,
      6: false,
    },

    {
      muscle: t("hamstring"),
      1: false,
      2: <S.Check className="__blue" />,
      3: false,
      4: false,
      5: <S.Check className="__blue" />,
      6: false,
    },
    {
      muscle: t("tibialis_anterior"),
      1: false,
      2: false,
      3: <S.Check />,
      4: false,
      5: false,
      6: <S.Check />,
    },
  ];

  // const tableDataTwo = [
  //   {
  //     muscle: t("left_quadriceps"),
  //     1: <S.Check className="__blue" />,
  //     2: false,
  //     3: false,
  //     4: <S.Check className="__blue" />,
  //     5: false,
  //     6: false,
  //   },

  //   {
  //     muscle: t("left_hamstring"),
  //     1: false,
  //     2: <S.Check className="__blue" />,
  //     3: false,
  //     4: false,
  //     5: <S.Check className="__blue" />,
  //     6: false,
  //   },
  //   {
  //     muscle: t("left_anterior_tibial"),
  //     1: false,
  //     2: false,
  //     3: <S.Check />,
  //     4: false,
  //     5: false,
  //     6: <S.Check />,
  //   },
  // ];

  return (
    <>
      <Title>
        {t("muscles_to_work")} <span className="__red">*</span>
      </Title>
      <S.Table>
        <S.RowHeader>
          {tableHeaders.map((header, i) => (
            <div
              key={i}
              className={`${header === 1 || header === 2 || header === 3 ? "__dark-bg" : null}`}
            >
              {header}
            </div>
          ))}
        </S.RowHeader>
        {tableData.map((row, i) => (
          <S.Row key={i}>
            <div>{row.muscle}</div>
            <div>{row[1]}</div>
            <div>{row[2]}</div>
            <div>{row[3]}</div>
            <div>{row[4]}</div>
            <div>{row[5]}</div>
            <div>{row[6]}</div>
          </S.Row>
        ))}
      </S.Table>
      {/* <S.Table>
        <S.RowHeader>
          {tableHeaders.map((header, i) => (
            <div
              key={i}
              className={`${
                header === 1 || header === 2 || header === 5 || header === 6 ? "__dark-bg" : null
              }`}
            >
              {header}
            </div>
          ))}
        </S.RowHeader>
        {tableDataTwo.map((row, i) => (
          <S.Row key={i}>
            <div>{row.muscle}</div>
            <div>{row[1]}</div>
            <div>{row[2]}</div>
            <div>{row[3]}</div>
            <div>{row[4]}</div>
            <div>{row[5]}</div>
            <div>{row[6]}</div>
          </S.Row>
        ))}
      </S.Table> */}
      <S.InfoText>
        <p>*{t("conf_suggested")}</p>
        <p>*{t("conf_optional")}</p>
      </S.InfoText>
      <S.ReferenceText>
        <strong>{t("this_table_is_not_intended")},</strong> {t("it_is_a_reference")}
      </S.ReferenceText>
    </>
  );
};
